import {useState} from 'react'
import Modal from '@/customComponents/uiComponents/modal/Modal.jsx'
import ModalHeader from '@/customComponents/uiComponents/modal/ModalHeader.jsx'
import WhyChooseUs from './WhyChooseUs.jsx'
import {InterestFreePaymentContent} from '@/customComponents/BookRideSteps/modalPages/interestFreePayment.jsx'
import {FlightDelayedContent} from '@/customComponents/BookRideSteps/Components/flightDelayedContent.jsx'
import {PayAfterDropoffContent} from '@/customComponents/BookRideSteps/modalPages/payAfterDropoff.jsx'
import {CancellationModificationRefundContent} from '@/customComponents/BookRideSteps/Components/cancellationModificationRefund.jsx'
import {tripCmrPolicy} from '@/customComponents/globalComponents/policyValues.js'

// Sub-views opened when a perk in "Why Choose us?" is tapped — keyed by the
// perk's `action` (see WHY_PERKS in constants/airportPerks.js). Each reuses the
// same content component as the booking flow's compare modal.
const PERK_VIEWS = {
    afterpay: {title: 'Ride now Pay later', Content: InterestFreePaymentContent},
    flight: {title: 'Flight tracking', Content: FlightDelayedContent},
    payafter: {title: '', Content: PayAfterDropoffContent},
    // cancellation is special — its Content is the trip-fed CMR popup (see below).
    cancellation: {title: 'Cancellation, Change & Refund'},
}

// "Exclusive Airport Pickup Perks" modal with nested perk detail views.
// Perks list (WhyChooseUs) → tap a perk → its detail content (with a Back arrow).
// `trip` is the GET-trip response — CMR reads its tiers from cancellation_policy /
// edit_policy.
//
// `fromCalculatedPolicies` flips CMR to the booking-flow source (/calculate-policies via
// POLICY_CONSTANTS) instead. /confirm passes it: a Draft carries neither policy object, so
// tripCmrPolicy() would hand CMR an object with empty tiers — and a PRESENT policy makes CMR
// pick its trip-page copy ("contact our admin") over the "$0 Free changes" default. Omitting
// the prop entirely is what gets the booking-flow behaviour.
export default function AirportPerksModal({isOpen, onClose, trip, fromCalculatedPolicies = false}) {
    const [perkView, setPerkView] = useState(null)
    const activePerk = perkView ? PERK_VIEWS[perkView] : null
    const close = () => { setPerkView(null); onClose() }

    let body
    if (!activePerk) {
        body = <WhyChooseUs onPerkAction={setPerkView}/>
    } else if (perkView === 'cancellation') {
        body = <CancellationModificationRefundContent policy={fromCalculatedPolicies ? undefined : tripCmrPolicy(trip)}/>
    } else {
        const PerkContent = activePerk.Content
        body = <PerkContent/>
    }

    return (
        <Modal isOpen={isOpen} onClose={close}>
            <ModalHeader
                title={activePerk ? activePerk.title : 'Exclusive Airport Pickup Perks'}
                onBack={activePerk ? () => setPerkView(null) : undefined}
                onClose={close}
            />
            {body}
        </Modal>
    )
}
